import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { css } from "styled-components";

userInformationStyles.userInformationTitle = {
    variant: "h3",
};
